if (!customElements.get('eu-guarantee-modal')) {
  class EuGuaranteeModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog')
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return
      this.controller = new AbortController()
      const options = { signal: this.controller.signal }
      // Delegation also covers links inserted by quick-add and PDP section swaps.
      document.addEventListener('click', this.handleTrigger.bind(this), options)
      this.dialog.addEventListener('click', this.handleDialogClick.bind(this), options)
      this.dialog.addEventListener('close', this.restoreFocus.bind(this), options)
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close()
      this.restoreFocus()
      this.controller?.abort()
    }

    handleTrigger(event) {
      const trigger = event.target.closest('[data-eu-guarantee-open]')
      if (!trigger || event.defaultPrevented || event.button !== 0) return
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
      event.preventDefault()
      if (this.dialog.open) return
      this.trigger = trigger
      const image = this.querySelector('[data-src]')
      if (image && !image.hasAttribute('src')) image.src = image.dataset.src
      this.previousOverflow = document.documentElement.style.overflow
      document.documentElement.style.overflow = 'hidden'
      this.dialog.showModal()
      this.querySelector('[data-eu-guarantee-close]').focus()
    }

    handleDialogClick(event) {
      if (event.target.closest('[data-eu-guarantee-close]')) {
        this.dialog.close()
        return
      }
      if (event.target !== this.dialog) return
      const rect = this.dialog.getBoundingClientRect()
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)
        this.dialog.close()
    }

    restoreFocus() {
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow
        this.previousOverflow = undefined
      }
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true })
      this.trigger = null
    }
  }
  customElements.define('eu-guarantee-modal', EuGuaranteeModal)
}
